<template>
  <validation-observer>
    <b-form slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)">
      <!-- Sub Category -->
      <form-input
        v-model="subCategoryFormData.subCategory"
        :disabled="loading"
        name="SubCategory"
        placeholder="Enter sub category name"
        rules="required"
        label="Sub Category"
      />

      <!-- Category Type -->

      <form-select
        v-model="subCategoryFormData.categoryType"
        label="Category Type"
        name="CategoryType"
        rules="required"
        :options="categoryOptions"
      />

      <!-- Further Tax -->
      <form-input
        v-model="subCategoryFormData.furtherTax"
        :disabled="loading"
        name="FurtherTax"
        placeholder="Enter further tax"
        rules="required|numeric"
        label="Further Tax"
      />

      <!-- Is Active -->
      <b-form-group label="Status" class="mb-3">
        <b-form-checkbox
          id="subcategory-active"
          v-model="subCategoryFormData.isActive"
          name="subcategory-active"
          value="true"
          unchecked-value="false"
          :disabled="loading"
        >
          Active
        </b-form-checkbox>
      </b-form-group>

      <div class="d-flex justify-content-end">
        <b-button
          type="button"
          variant="outline-secondary"
          :disabled="loading"
          class="mr-1"
          @click="$emit('cancel')"
        >
          Cancel
        </b-button>
        <b-button type="submit" variant="primary" :disabled="loading">
          <b-spinner small v-if="loading" class="mr-1"></b-spinner>
          {{ loading ? 'Saving...' : 'Save Sub Category' }}
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import { BForm, BFormGroup, BFormCheckbox, BButton, BSpinner } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { ref, computed, watch } from '@vue/composition-api';
import store from '@/store';
import { FormInput, FormSelect } from '@/views/apps/fbr-invoice/components/form';

export default {
  name: 'SubCategoryForm',
  components: {
    BForm,
    BFormGroup,
    BFormCheckbox,
    BButton,
    BSpinner,

    // Form Validation
    ValidationObserver,
    ValidationProvider,

    // Custom Components
    FormInput,
    FormSelect,
  },
  model: {
    prop: 'formData',
    event: 'update:form-data',
  },
  props: {
    formData: {
      type: Object | null,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    modalMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit', 'update:form-data', 'cancel'],
  setup(props, { emit }) {
    const businessID = computed(() => store.state.user.businessID);

    const categoryOptions = [
      { value: 'Registered', text: 'Registered' },
      { value: 'Unregistered', text: 'Unregistered' },
    ];

    const subCategoryFormData = ref(
      props.formData
        ? JSON.parse(JSON.stringify(props.formData))
        : {
            id: 0,
            subCategory: '',
            categoryType: '',
            furtherTax: 0,
            isActive: true,
            businessID: businessID.value,
          }
    );

    const onSubmit = async () => {
      console.log('Emitting:', JSON.stringify(subCategoryFormData.value, null, 2));
      emit('submit');
    };

    watch(
      subCategoryFormData,
      (newVal) => {
        emit('update:form-data', {
          ...newVal,
          furtherTax: parseFloat(newVal.furtherTax),
        });
      },
      { deep: true }
    );

    return {
      categoryOptions,
      subCategoryFormData,
      onSubmit,
    };
  },
};
</script>
